import { connect } from 'react-redux';
import _sortBy from 'lodash/sortBy';

import ChannelList from './channellist';

const mapStateToProps = state => ({
  channels: _sortBy(state.channels, ['logical_channel_number']),
});

export default connect(mapStateToProps, null)(ChannelList);
